// extracted by mini-css-extract-plugin
export default {"mainContainer":"telegram_mainContainer__lupnS","leftSection":"telegram_leftSection__oO++e","rightSection":"telegram_rightSection__EpWtC"};